import { theme } from '@sbv-clients/ui-shared';

export const authLabelSx = {
  fontSize: '13px',
  fontWeight: 500,
  color: theme.custom?.stepText,
};

export const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    minHeight: 44,
    borderRadius: '8px',
    backgroundColor: theme.background.white,
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${theme.custom?.controlBorder}`,
    borderRadius: '8px',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.colors.primary.main,
  },
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.custom?.fieldErrorBorder,
  },
  '& .MuiInputAdornment-root svg, & .MuiInputAdornment-root .MuiSvgIcon-root': {
    color: theme.custom?.iconButton,
  },
};

export const authButtonSx = {
  height: 44,
  borderRadius: '8px',
  fontSize: '15px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': { boxShadow: 'none' },
} as const;
